import React from 'react';
import NavBarSub from '../layout/NavBarSub';
import SubTeam from '../layout/SubTeam';
import TeamContent from '../layout/TeamContent';
import OurPeople from '../layout/OurPeople';

const Team = () => {
  return (
    <>
      <NavBarSub />
      <SubTeam />
      <TeamContent />
      <OurPeople />
    </>
  );
};

export default Team;
